import {Utils} from "../common/utils";
import useSWR from "swr";
import {LabelGroup, Label} from "Stores/labelStore";

const clientConfigs = Utils.getEAIClientConfigs();

export interface LabelsResponse {
    data: Label[]
}

export interface LabelGroupResponse {
    data: LabelGroup[]
}

export function useLabels() {
    const {data, mutate} = useSWR<LabelsResponse, Error>(`${clientConfigs.endpoint}/schools/${clientConfigs.school}/labels?grouped=false`);
    return {data, mutate};
}

export function useLabelGroups() {
    const {data, mutate} = useSWR<LabelGroupResponse, Error>(`${clientConfigs.endpoint}/schools/${clientConfigs.school}/labels?grouped=true`);

    return {data, mutate};
}
